import OurTrainersComponent from "../../components/become-trainer/our-trainers";

const OurTrainersPage = () => <OurTrainersComponent/>

export default OurTrainersPage;